import { Expose } from "class-transformer";
import { IsBoolean, IsOptional, IsString } from "class-validator";

export class AutocompleteDataItem {
  @IsOptional()
  @IsString()
  @Expose()
  label!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  value!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  uniqueId!: string | null;
  @IsOptional()
  @IsBoolean()
  @Expose()
  isConditionMet!: boolean | null;
}

export type AutocompleteDataResult = Array<AutocompleteDataItem>;
